import { LinkProps, Link } from '@mui/material'
import React from 'react'

type WcLinkProps = LinkProps

export const WcLink = ({children,...props}: WcLinkProps) => (
    <Link {...props}>
      {children}
    </Link>
  )